import React, { useEffect, useMemo, useState } from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    AspectRatio as SizeIcon,
    DynamicFeed,
} from "@material-ui/icons";
import DataTable from "../../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../../components/confirm-modal-content";
import formSectionService from "../../../../services/form-section.service";
import FormQuestionsPage from "./form-question";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
    },
];

export default function FormSectionsPage(props) {
    const { data, extra } = props

    const [sections, setSections] = useState([]);

    const deleteItem = (item) => {
        return formSectionService.deleteFormSection(item.id);
    };
    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "نام",
                mainField: false,
            },
            {
                field: "description",
                title: "توضیح",
            },
            {
                field: "questionsCount",
                title: "تعداد سوال",
            },
        ],
        []
    );

    const onRefresh = async () => {
        const { data, error } = await formSectionService.getFormSections(props.data.id);
        if (error || !data) {
            return;
        }
        setSections(data.map(item => ({
            ...item,
        })));
    };

    useEffect(() => {
        onRefresh();
    }, []);

    return (
        <div className="p-3">
            <DataTable
            order={{order: "ASC", orderBy: "step"}}
                headCells={headerCells}
                data={sections}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        icon: <DynamicFeed />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <FormQuestionsPage {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <EditIcon />,
                        modalContent: (p) => <FormModalContent {...p} parent={data} extra={extra} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "md" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد بخش",
                        modalContent: (p) => (
                            <FormModalContent {...p} parent={data} extra={extra} />
                        ),
                    },
                ]}
                searchKeys={defaultKeys}
                title={`بخش های فرم  "${data.title}"`}
            />
        </div>
    );
}
